import { Box, Grid } from '@mui/material';
import { useEffect, useState } from 'react';

import { FacebookProvider, Page } from 'react-facebook';
import Head from '../components/commons/Head';
import Text from '../components/commons/Text';
import WelcomeSection from '../components/welcome/WelcomeSection';
import { IEvent } from '../models/IEvent';
import { IFanfare } from '../models/IFanfare';
import { IFanfaron } from '../models/IFanfaron';
import { IWelcomeItem } from '../models/IWelcomeItem';
import { IWelcomeWording } from '../models/IWording';

const welcomeWordings: IWelcomeWording = require("../assets/configuration/wordings/welcome.json");
const fanfaronsDatabase: IFanfaron[] = require("../assets/configuration/database/fanfarons.json");
const eventsDatabase: IEvent[] = require("../assets/configuration/database/events.json");
const fanfaresDatabase: IFanfare[] = require("../assets/configuration/database/fanfares.json");

const WelcomeView = () => {

    const [fanfarons, setFanfarons] = useState([] as IWelcomeItem[]);
    const [events, setEvents] = useState([] as IWelcomeItem[]);
    const [fanfares, setFanfares] = useState([] as IWelcomeItem[]);

    useEffect(() => {
        setFanfarons(
            shuffle(fanfaronsDatabase.filter(f => !f.old))
            .map(fanfaron => ({
                id: fanfaron.id,
                title: fanfaron.nickname,
                image: fanfaron.photo,
                link: `/fanfarons/${fanfaron.nickname}`
            }) as IWelcomeItem));

        setEvents(eventsDatabase
            .map(event => ({
                id: event.id,
                title: event.name,
                image: event.image,
                link: `/events/${event.id}`
            }) as IWelcomeItem));
        
        setFanfares(shuffle(fanfaresDatabase)
            .map(fanfare => ({
                id: fanfare.id,
                title: fanfare.name,
                image: fanfare.image,
                link: `/fanfares/${fanfare.id}`
            }) as IWelcomeItem));
    }, []);

    const shuffle = (items: any[]) => items.slice().sort(() => 0.5 - Math.random());

    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={9} lg={9} xl={9} sx={{paddingRight: "30px"}}>
                    <Head title={welcomeWordings.title} subtitle={welcomeWordings.description}/>
                    <Box sx={{marginTop: "40px"}}>
                        <Text text={welcomeWordings.welcomeText}/>
                    </Box>
                </Grid>

                <Grid item xs={12} md={3} lg={3} xl={3}>
                    <FacebookProvider appId="YOUR_APP_ID">
                        <Page href="https://www.facebook.com/terminusbrassband" tabs="timeline" />
                    </FacebookProvider>
                </Grid>
                
            </Grid>

            <WelcomeSection
                title="Nos fanfarons"
                label="fanfarons"
                link={"/fanfarons"}
                items={fanfarons}/>

            <WelcomeSection
                title="Nos évènements"
                label="évènements"
                link={"/events"}
                items={events}/>
            
            <WelcomeSection
                title="Nos amies les fanfares"
                label="fanfares"
                link={"/fanfares"}
                items={fanfares}/>

        </Box>
    );
}

export default WelcomeView;